import classnames from "classnames";
import { MultiSelect } from "react-multi-select-component";
import { useEffect, useRef, useState } from "react";
import { Teams, TimeIcon } from "components/assets/Icons";
import TeamMembers from "../TeamMembers";
import UserInfo from "components/UserInfo";

import styles from "./Filter.module.scss";

const Filter = ({
  team,
  selectedTeams,
  setSelectedTeams,
  selectedMembers,
  setSelectedMembers,
  employeesPhotos,
  setEmployeesPhotos,
  schedule,
  selectedSchedule,
  setSelectedSchedule,
  className,
  checkbox,
}) => {
  const refFilterHeader = useRef();
  const [open, setOpen] = useState(true);
  const [selected, setSelected] = useState([]);

  function setFilterHeight() {
    if (typeof window === "object") {
      return document.documentElement.style.setProperty(
        "--filter-height",
        `${refFilterHeader.current?.offsetHeight}px`
      );
    }
  }

  useEffect(() => {
    setFilterHeight();
  }, [open]);

  /* For Teams */
  const teamsOptions = Array.isArray(team)
    ? team
    : Object.keys(team)?.map((item) => {
        return {
          label: item !== "null" ? item : "No Team Assigned",
          value: item !== "null" ? item : "No Team Assigned",
          members: team[item].map(({ first_name, last_name }) => {
            return `${first_name} ${last_name}`;
          }),
        };
      });

  const teamsRenderer = (selected) => {
    if (!selected.length) {
      return <Teams />;
    }

    if (selected.length > 1) {
      return (
        <>
          <Teams /> {`${selected.length} selected`}
        </>
      );
    } else if (selected.length === 1) {
      return (
        <>
          <Teams /> {selected[0]?.label}
        </>
      );
    }
  };

  /* For Schedule */
  const scheduleOptions =
    schedule &&
    Object.keys(schedule)?.map((item) => {
      return {
        label: item,
        value: item,
        members: schedule[item]?.map(({ first_name, last_name }) => {
          return `${first_name} ${last_name}`;
        }),
      };
    });

  const scheduleRenderer = (selected) => {
    if (!selected.length) {
      return <TimeIcon />;
    }

    if (selected.length > 1) {
      return (
        <>
          <TimeIcon /> {`${selected.length} selected`}
        </>
      );
    } else if (selected.length === 1) {
      return (
        <>
          <TimeIcon /> {selected[0]?.label}
        </>
      );
    }
  };

  const filterOptions = (options, filter) => {
    if (!filter) {
      return options;
    }

    return options.filter(({ label }) => {
      return label && label?.toLowerCase().includes(filter);
    });
  };

  const handleClick = (e, type) => {
    type === "team" && setSelectedTeams(e);
    type === "schedule" && setSelectedSchedule(e);
  };

  useEffect(() => {
    /* Temporarily disabled team and schedule filtering
    const selectedArray = [];
    const finalArray = selectedTeams.concat(selectedSchedule);

    (schedule ? Array.from(new Set(finalArray)) : selectedTeams)?.map(
      ({ members }) => {
        const newArray = members.map((item) => {
          return {
            label: <UserInfo src={employeesPhotos.get(item)} name={item} />,
            value: item,
          };
        });
        selectedArray.push(...newArray);

        return setSelected(selectedArray);
      }
    );
    */

    // Simplified filtering logic while team and schedule filters are disabled
    if (selected?.length > 0) {
      const arr = selected.map(({ value }) => value);
      setSelectedMembers(arr);
    } else {
      setSelectedMembers([]);
    }
  }, [selected, setSelectedMembers]); // When re-enabling, add back: selectedTeams, selectedSchedule

  return (
    <div ref={refFilterHeader}>
      {open && (
        <form
          className={classnames(styles.wrapper, className)}
          method="GET"
          action="submit"
        >
          {/* Hidden temporarily
          <span className={styles.group}>
            <label htmlFor="team" className={styles.label}>
              Team
            </label>
            <MultiSelect
              className={classnames(styles.select, styles.select_middle)}
              options={teamsOptions}
              value={selectedTeams}
              onChange={(e) => handleClick(e, "team")}
              valueRenderer={teamsRenderer}
              filterOptions={filterOptions}
            />
          </span>
          */}

          <TeamMembers
            members={selectedMembers}
            className={styles.multiselect}
            selected={selected}
            setSelected={setSelected}
            employeesPhotos={employeesPhotos}
            setEmployeesPhotos={setEmployeesPhotos}
          />

          {/* Hidden temporarily
          {schedule && (
            <span className={styles.group}>
              <label htmlFor="schedule" className={styles.label}>
                Schedule
              </label>
              <MultiSelect
                className={classnames(styles.select, styles.select_middle)}
                options={scheduleOptions}
                value={selectedSchedule}
                onChange={(e) => handleClick(e, "schedule")}
                valueRenderer={scheduleRenderer}
                filterOptions={filterOptions}
              />
            </span>
          )}
          */}
        </form>
      )}
      <div className={styles.footer}>
        <button
          className={classnames(styles.toogle, open ? styles.active : "")}
          onClick={() => setOpen(!open)}
        >
          {open ? "Hide Filters" : "Show Filters"}
        </button>
        {checkbox}
      </div>
    </div>
  );
};

export default Filter;
